"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Text = _interopRequireDefault(require("@icare/rhythm-form-react/lib/controls/Text"));

var _Select = _interopRequireDefault(require("@icare/rhythm-form-react/lib/controls/Select"));

var _InlineFields = _interopRequireDefault(require("../InlineFields"));

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ADDRESS_FIELDS = {
  province: 'province',
  postalCode: 'postalCode',
  country: 'country'
};

var CountrySelect = /*#__PURE__*/function (_React$Component) {
  _inherits(CountrySelect, _React$Component);

  var _super = _createSuper(CountrySelect);

  function CountrySelect(props) {
    var _this;

    _classCallCheck(this, CountrySelect);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "constructOptionList", function (attributes) {
      return attributes.map(function (item) {
        return {
          id: item.code,
          label: item.name,
          value: item.code,
          disabled: false
        };
      }).sort(function (a, b) {
        return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCountryChange", function (e) {
      var handleManualInputChange = _this.props.handleManualInputChange;
      var _this$state = _this.state,
          defaultCountryCode = _this$state.defaultCountryCode,
          defaultStateCode = _this$state.defaultStateCode;

      if (e.target.value === defaultCountryCode) {
        _this.setState({
          renderStateSelect: true
        });

        handleManualInputChange(defaultStateCode, ADDRESS_FIELDS.province);
      } else {
        _this.setState({
          renderStateSelect: false
        });

        handleManualInputChange('', ADDRESS_FIELDS.province);
      }
    });

    _this.state = {
      renderCountrySelect: false,
      renderStateSelect: false,
      countryList: [],
      stateList: [],
      defaultCountryCode: 'AUS',
      defaultStateCode: 'NSW'
    };
    return _this;
  }

  _createClass(CountrySelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          handleManualInputChange = _this$props.handleManualInputChange,
          service = _this$props.service,
          address = _this$props.address;
      var _this$state2 = this.state,
          defaultCountryCode = _this$state2.defaultCountryCode,
          defaultStateCode = _this$state2.defaultStateCode;
      service.getCountryList().then(function (resp) {
        if (resp && resp.data && resp.data.attributes) {
          _this2.setState({
            countryList: _this2.constructOptionList(resp.data.attributes),
            renderCountrySelect: true,
            renderStateSelect: !address.country ? true : address.country === defaultCountryCode
          });

          handleManualInputChange(address.country || defaultCountryCode, ADDRESS_FIELDS.country);
        }
      }).catch(function (e) {
        _this2.setState({
          renderCountrySelect: false
        });

        throw e;
      });
      service.getStateList().then(function (resp) {
        if (resp && resp.data && resp.data.attributes) {
          _this2.setState({
            stateList: _this2.constructOptionList(resp.data.attributes)
          });

          if (!address.country || address.country === defaultCountryCode) {
            handleManualInputChange(address.province || defaultStateCode, ADDRESS_FIELDS.province);
          } else {
            _this2.setState({
              renderStateSelect: false
            });
          }
        }
      }).catch(function (e) {
        _this2.setState({
          renderStateSelect: false
        });

        throw e;
      });
    }
  }, {
    key: "renderStateInput",
    value: function renderStateInput() {
      var _this$props2 = this.props,
          handleManualInputChange = _this$props2.handleManualInputChange,
          checkIfValidInput = _this$props2.checkIfValidInput,
          onBlur = _this$props2.onBlur,
          onFocus = _this$props2.onFocus,
          address = _this$props2.address,
          error = _this$props2.error,
          required = _this$props2.required;
      var _this$state3 = this.state,
          renderStateSelect = _this$state3.renderStateSelect,
          stateList = _this$state3.stateList;

      if (renderStateSelect) {
        return /*#__PURE__*/_react.default.createElement(_Select.default, {
          label: "State",
          name: "structuredAddressProvince",
          options: stateList,
          required: required,
          value: address.province,
          onChange: function onChange(evt) {
            handleManualInputChange(evt.target.value, ADDRESS_FIELDS.province);
          },
          width: "l"
        });
      }

      return /*#__PURE__*/_react.default.createElement(_Text.default, {
        label: "State",
        name: "structuredAddressProvince",
        value: address.province,
        autoComplete: "address-level1",
        required: required,
        onChange: function onChange(evt) {
          handleManualInputChange(evt.target.value, ADDRESS_FIELDS.province);
        },
        width: "l",
        error: error.State,
        onBlur: onBlur,
        onFocus: onFocus,
        className: checkIfValidInput(address.province, error.State)
      });
    }
  }, {
    key: "renderCountryInput",
    value: function renderCountryInput() {
      var _this3 = this;

      var _this$props3 = this.props,
          handleManualInputChange = _this$props3.handleManualInputChange,
          checkIfValidInput = _this$props3.checkIfValidInput,
          onBlur = _this$props3.onBlur,
          onFocus = _this$props3.onFocus,
          address = _this$props3.address,
          error = _this$props3.error,
          required = _this$props3.required;
      var _this$state4 = this.state,
          renderCountrySelect = _this$state4.renderCountrySelect,
          countryList = _this$state4.countryList;

      if (renderCountrySelect) {
        return /*#__PURE__*/_react.default.createElement(_Select.default, {
          label: "Country",
          name: "structuredAddressCountry",
          options: countryList,
          required: required,
          value: address.country,
          onChange: function onChange(evt) {
            _this3.handleCountryChange(evt);

            handleManualInputChange(evt.target.value, ADDRESS_FIELDS.country);
          },
          width: "l"
        });
      }

      return /*#__PURE__*/_react.default.createElement(_Text.default, {
        label: "Country",
        name: "structuredAddressCountry",
        value: address.country,
        autoComplete: "country-name",
        onChange: function onChange(evt) {
          handleManualInputChange(evt.target.value, ADDRESS_FIELDS.country);
        },
        width: "l",
        required: required,
        error: error.Country,
        onBlur: onBlur,
        onFocus: onFocus,
        className: checkIfValidInput(address.country, error.Country)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          address = _this$props4.address,
          handleManualInputChange = _this$props4.handleManualInputChange,
          checkIfValidInput = _this$props4.checkIfValidInput,
          error = _this$props4.error,
          onBlur = _this$props4.onBlur,
          onFocus = _this$props4.onFocus,
          required = _this$props4.required;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_InlineFields.default, {
        width: "l",
        weights: [65, 35],
        fields: [this.renderStateInput(), /*#__PURE__*/_react.default.createElement(_Text.default, {
          key: "countrySelectPostCode",
          label: "Postcode",
          name: "structuredAddressPostalCode",
          value: address.postalCode,
          autoComplete: "postal-code",
          required: required,
          onChange: function onChange(evt) {
            handleManualInputChange(evt.target.value, ADDRESS_FIELDS.postalCode);
          },
          width: "l",
          error: error.Postcode,
          onBlur: onBlur,
          onFocus: onFocus,
          className: checkIfValidInput(address.postalCode, error.Postcode)
        })]
      }), this.renderCountryInput());
    }
  }]);

  return CountrySelect;
}(_react.default.Component);

exports.default = CountrySelect;

_defineProperty(CountrySelect, "defaultProps", {
  service: _.globalConfig.addressService,
  required: false
});

_defineProperty(CountrySelect, "propTypes", {
  address: _propTypes.default.object.isRequired,
  handleManualInputChange: _propTypes.default.func.isRequired,
  checkIfValidInput: _propTypes.default.func.isRequired,
  error: _propTypes.default.object.isRequired,
  onBlur: _propTypes.default.func.isRequired,
  onFocus: _propTypes.default.func.isRequired,
  service: _propTypes.default.func,
  required: _propTypes.default.bool
});
//# sourceMappingURL=CountrySelect.js.map